import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function safeParseInt(value: string, fallback = null): number | null {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? fallback : parsed;
}

type LocalizedPaths = {
  [route: string]: {
    en: string;
    tr: string;
    ar: string;
  };
};

// --- UTILITY FUNCTION TO GENERATE PUBLIC PATHS ---
/**
 * Extracts all unique localized pathnames from the localeConfig.
 * @param {object} pathnamesConfig - The `pathnames` object from `localeConfig`.
 * @returns {string[]} An array of unique URL pathnames.
 */
export const generatePublicPaths = (pathnamesConfig: LocalizedPaths) => {
  // 1. `Object.values(pathnamesConfig)` gets an array of the inner objects, e.g., [{en: '/contact', tr: '/iletisim'}, {...}]
  // 2. `.flatMap(Object.values)` then gets all the string values from those inner objects, e.g., ['/contact', '/iletisim', '/sign-up', ...]
  const allPaths = Object.values(pathnamesConfig).flatMap((localeMap) =>
    Object.values(localeMap),
  );

  // 3. `new Set(allPaths)` filters the list to ensure every path is unique.
  // 4. `[...new Set(allPaths)]` converts the Set back into an array.
  return [...new Set(allPaths)];
};
